export const SITE_URL = "https://www.eikainteriors.com";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Apply per-route title/description/canonical + Open Graph.
 *
 * NOTE: this runs client-side. Google renders JS and will pick it up, but
 * non-rendering crawlers (WhatsApp, Facebook, LinkedIn link previews) only read
 * the static HTML, so they fall back to the defaults in public/index.html.
 * Pre-rendering at build time is the fix — see notes in README.
 */
export function applyHead(route) {
  const meta = route.meta || {};
  const url = SITE_URL + (route.path === "/" ? "/" : route.path);

  if (meta.title) {
    document.title = meta.title;
    upsertMeta("property", "og:title", meta.title);
  }
  if (meta.description) {
    upsertMeta("name", "description", meta.description);
    upsertMeta("property", "og:description", meta.description);
  }
  upsertMeta("property", "og:url", url);
  upsertCanonical(url);
}
